<template lang="pug">
  .gift-card-media
    DynamicMedia(:config="imageConfig" cover)
      .amount(v-if="giftcardConfig.amount")
        p {{ $rogue.currency(giftcardAmount) }}
    .code(v-if="giftcardConfig.senderName") {{__('Gift Card Code: ABCDEFGHIJK...')}}
    .message(v-if="giftcardConfig.senderName")
      div {{giftcardConfig.message}}
      br
      p {{giftcardConfig.senderName}}
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { BuyRequest, GiftcardMetadata } from '@/js/services/types/order'

const props = defineProps<{
  buyRequest: BuyRequest
}>()

const giftcardConfig = computed(() => props.buyRequest.metadata?.giftcard as GiftcardMetadata)

const imageConfig = computed(() => ({
  src: giftcardConfig.value?.design,
}))

const giftcardAmount = computed(() => giftcardConfig.value.customAmount || giftcardConfig.value.amount)
</script>

<style lang="scss" scoped>
.gift-card-media {
  padding: 10%;
}

.gift-card-media .code {
  padding: $size-s;
  padding: $size-s;
  background-color: $color-black-light;
  border: 2px solid $color-black-light;
  color: $color-white;
  font-size: $size-xs;
  font-weight: bold;
  max-width: 600px;
  margin: 0 auto;
}

.gift-card-media .amount {
  position: relative;
  width: 100%;
  height: 100%;
}

.gift-card-media .amount p {
  position: absolute;
  bottom: -32px;
  right: 0px;
  font-family: $font-condensed;
  font-weight: $weight-bold;
  font-size: $size-xxxl;
  color: $color-white;

  @include mobile() {
    font-size: $size-xl;
  }
}

.gift-card-media .message {
  padding: $size-s;
  border: 2px solid $color-black-light;
  max-width: 600px;
  margin: 0 auto;
  word-wrap: break-word;
}
</style>

<style lang="scss">
  .gift-card-media .media-wrap {
    box-shadow: 0px 14px 14px -14px #303030;
    max-width: 600px;
    margin: 0 auto;
  }
</style>
